import {Component, Input, OnInit} from '@angular/core';
import {UserStorageService} from "../../../services/user-storage-service/user-storage.service";
import {BroadcastingsService} from "../../../services/broadcastings-services/broadcastings.service";
import {FormControl, FormGroup} from "@angular/forms";
import {tap} from "rxjs/internal/operators/tap";
import {catchError} from "rxjs/internal/operators/catchError";
import {EMPTY} from "rxjs";
import {Subscription} from "rxjs/internal/Subscription";
import {SnackBarService} from "../../shared-components/snack-bar/snack-bar.service";
import {
  BroadcastingModesEnum,
  LanguageIconsEnum
} from "../../turns-components/turns-config-ui-card/turns-config-ui-card.component";

@Component({
  selector: 'app-broadcastings-config-default-center-config-card',
  templateUrl: './broadcastings-config-default-center-config-card.component.html',
  styleUrls: ['./broadcastings-config-default-center-config-card.component.scss']
})
export class BroadcastingsConfigDefaultCenterConfigCardComponent implements OnInit {

  @Input() config;
  centers;
  layouts;

  getBroadcastingLayoutsSubscription: Subscription;

  basicDataForm = new FormGroup({
    selectedCenter: new FormControl(null),
    selectedLayout: new FormControl(null),
    backgroundColor: new FormControl("#FFFFFF"),
    textPrimaryColor: new FormControl("#000000"),
    textSecondaryColor: new FormControl("#000000"),
    overrideDevicesValues: new FormControl(false),
    showOfflineChip: new FormControl(true)
  });

  constructor(private userStorageService: UserStorageService,
              private broadcastingsService: BroadcastingsService,
              private snackbarService: SnackBarService) {
    this.centers = this.userStorageService.getCenterList();
    this.getBroadcastLayouts();
  }

  // this.basicDataForm.get('selectedCenter').value.internalId

  ngOnInit() {
    this.lockEdition();
  }

  private unlockEdition() {
    this.basicDataForm.get('selectedLayout').enable();
    this.basicDataForm.get('backgroundColor').enable();
    this.basicDataForm.get('textPrimaryColor').enable();
    this.basicDataForm.get('textSecondaryColor').enable();
    this.basicDataForm.get('overrideDevicesValues').enable();
    this.basicDataForm.get('showOfflineChip').enable();
  }

  private lockEdition() {
    this.basicDataForm.get('selectedLayout').disable();
    this.basicDataForm.get('backgroundColor').disable();
    this.basicDataForm.get('textPrimaryColor').disable();
    this.basicDataForm.get('textSecondaryColor').disable();
    this.basicDataForm.get('overrideDevicesValues').disable();
    this.basicDataForm.get('showOfflineChip').disable();
  }

  private getBroadcastLayouts() {
    this.getBroadcastingLayoutsSubscription = this.broadcastingsService.getBroadcastingLayouts().pipe(
      tap(o => {
        this.layouts = o;
      }),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getBroadcastCenterConfig() {
    this.basicDataForm.get('selectedCenter').value.InternalId
    this.getBroadcastingLayoutsSubscription = this.broadcastingsService.getBroadcastCenterConfig(this.basicDataForm.get('selectedCenter').value.InternalId).pipe(
      tap(o => {
        this.config = o;
        this.fillForm();
        this.unlockEdition();
      }),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public updateBroadcastCenterConfig() {
    this.getBroadcastingLayoutsSubscription = this.broadcastingsService.updateBroadcastCenterConfig(
      this.basicDataForm.get('selectedCenter').value.InternalId,
      this.basicDataForm.get('selectedLayout').value.InternalId,
      this.basicDataForm.get('backgroundColor').value,
      this.basicDataForm.get('textPrimaryColor').value,
      this.basicDataForm.get('textSecondaryColor').value,
      this.basicDataForm.get('overrideDevicesValues').value,
      this.basicDataForm.get('showOfflineChip').value
    ).pipe(
      tap(o => {
        this.config = null;
        this.clearForm();
        this.lockEdition()
      }),
      catchError(error => {
        console.log(error);
        this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; }
      )
    ).subscribe();
  }

  public fillForm() {
    console.dir(this.config);
    console.log("Layout encontrado:", this.layouts.find(l => l.internalId === this.config.layoutInternalId));
    this.basicDataForm.patchValue({
      selectedLayout: this.layouts.find(l => l.internalId === this.config.layoutInternalId),
      backgroundColor: this.config.backgroundColor ? this.config.backgroundColor : "#FFFFFF",
      textPrimaryColor: this.config.textPrimaryColor ? this.config.textPrimaryColor : "#000000",
      textSecondaryColor: this.config.textSecondaryColor ? this.config.textSecondaryColor : "#000000",
      showOfflineChip: this.config.showOfflineChip
    });
  }

  public clearForm() {
    this.basicDataForm.patchValue({
      selectedCenter: null,
      selectedLayout: null,
      backgroundColor: "#FFFFFF",
      textPrimaryColor: "#000000",
      textSecondaryColor: "#000000",
      overrideDevicesValues: false,
      showOfflineChip: true
    });
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.internalId === op2.internalId;
    }
  }

  public updateDefaultCenterConfig() {
    // this.updateAssignmentModeSubscription = this.broadcastingService.updateBroadcastingsAssignmentModeConfig(
    //   this.basicDataForm.get('selectedAssignmentMode').value
    // ).pipe(
    //   tap(o => this.broadcastingService.refreshConfig()),
    //   catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    // ).subscribe();
  }

}
